import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const EditNameIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      id={props.id}
      viewBox="0 0 24 24"
      sx={{ height: '24px', width: '24px', fill: 'transparent', ...sx }}
      {...props}
    >
      <path
        id={props.id}
        d="M12 19.9395H20.4107M3.58936 19.9394H5.15425C5.6114 19.9394 5.83998 19.9394 6.05508 19.8878C6.24579 19.842 6.42811 19.7665 6.59533 19.664C6.78395 19.5484 6.94558 19.3868 7.26883 19.0636L19.009 7.3236C19.7832 6.54943 19.7832 5.29425 19.009 4.52008C18.2348 3.74591 16.9796 3.74591 16.2054 4.52008L4.46525 16.26C4.14199 16.5833 3.98036 16.7449 3.86478 16.9335C3.7623 17.1008 3.68678 17.2831 3.641 17.4738C3.58936 17.6889 3.58936 17.9175 3.58936 18.3746V19.9394Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export default EditNameIcon;
